'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var lotamePrefix = 'Seek : Job Search :';
var domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?([^:\/\n]+)/i;

var stripSpaceAndLowerCase = function stripSpaceAndLowerCase(value) {
  return value.replace(/[^a-z\d]/ig, '').toLowerCase();
};

var convertSpaceToPlusAndLowerCase = function convertSpaceToPlusAndLowerCase(value) {
  return value.replace(/[^a-z\d]/ig, '+').toLowerCase();
};

exports.default = function (state) {
  var searchDateRange = state.searchDateRange;
  var searchWorkType = state.searchWorkType;
  var searchClassification = state.searchClassification;
  var searchSubClassification = state.searchSubClassification;
  var searchSalaryRange = state.searchSalaryRange;
  var searchSalaryType = state.searchSalaryType;
  var searchKeywords = state.searchKeywords;
  var searchAdvertiserId = state.searchAdvertiserId;
  var searchSortMode = state.searchSortMode;
  var searchGraduate = state.searchGraduate;
  var searchLocation = state.searchLocation;
  var searchArea = state.searchArea;


  var interests = [];
  var userGenerated = [];

  if (searchDateRange) {
    interests.push(lotamePrefix + ' Date Range : ' + searchDateRange);
  }

  if (searchWorkType) {
    searchWorkType.split(',').forEach(function (workType) {
      interests.push(lotamePrefix + ' Work Type : ' + workType);
    });
  }

  if (searchClassification) {
    searchClassification.split(',').forEach(function (classification) {
      interests.push(lotamePrefix + ' Industry : ' + classification);
    });
  }

  if (searchSubClassification) {
    searchSubClassification.split(',').forEach(function (subClassification) {
      interests.push(lotamePrefix + ' Occupation : ' + subClassification);
    });
  }

  if (searchSalaryRange) {
    var _searchSalaryRange$sp = searchSalaryRange.split('-');

    var _searchSalaryRange$sp2 = _slicedToArray(_searchSalaryRange$sp, 2);

    var salaryMin = _searchSalaryRange$sp2[0];
    var salaryMax = _searchSalaryRange$sp2[1];


    if (salaryMin) {
      interests.push(lotamePrefix + ' Salary Min : ' + salaryMin);
    }

    if (salaryMax) {
      interests.push(lotamePrefix + ' Salary Max : ' + salaryMax);
    }
  }

  if (searchSalaryType) {
    var salaryType = stripSpaceAndLowerCase(searchSalaryType);

    interests.push(lotamePrefix + ' Salary Type : ' + salaryType);
  }

  if (searchKeywords) {
    var keywords = convertSpaceToPlusAndLowerCase(searchKeywords);

    userGenerated.push(lotamePrefix + ' Keywords : ' + keywords);
  }

  if (searchLocation) {
    var location = stripSpaceAndLowerCase(searchLocation);

    interests.push(lotamePrefix + ' Location : ' + location);
  }

  if (searchArea) {
    var area = stripSpaceAndLowerCase(searchArea);

    interests.push(lotamePrefix + ' Area : ' + area);
  }

  if (searchSortMode) {
    var sortMode = stripSpaceAndLowerCase(searchSortMode);

    interests.push(lotamePrefix + ' Sort Mode : ' + sortMode);
  }

  if (searchAdvertiserId) {
    interests.push(lotamePrefix + ' Advertiser ID : ' + searchAdvertiserId);
  }

  if (searchGraduate) {
    interests.push(lotamePrefix + ' Graduate Search : true');
  }

  if (typeof document !== 'undefined') {
    var _document = document;
    var domain = _document.domain;
    var referrer = _document.referrer;


    if (domain) {
      interests.push(domain + ' : Total Site Traffic');
    }

    if (referrer) {
      var referrerDomain = referrer.match(domainRegex);

      if (referrerDomain) {
        interests.push(referrerDomain[1] + ' : Referrer Site');
      }
    }
  }

  return {
    lotameInterests: interests,
    lotameUserGenerated: userGenerated
  };
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@seek/seek-jobs-analytics/build/utils/evaluateLotameValues.js
 ** module id = 427
 ** module chunks = 0
 **/